import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    width: 420,
    maxWidth: 420,
    padding: '16px',
    borderRadius: '16px',
    boxShadow: '0 10px 40px 0 rgba(0, 0, 0, 0.08)',
    position: 'relative',
    top: '12px',
    fontSize: '1rem',
  },
}));

export { CustomTooltip };
